/**
 * Environment Configuration
 * Centralized access to all environment variables
 *
 * LOCAL DEVELOPMENT (npm run dev / npm run uat / npm run prod):
 * - Uses the respective .env.<mode> file to set the environment keys.
 *
 * DEPLOYED BUILDS (Jenkins):
 * - Variables are exported into the environment via Jenkinsfile and HashiCorp Vault at build time.
 */

export const API_KEY = process.env.REACT_APP_API_KEY ?? "";
export const API_BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

export const ENCRYPTION_KEY = process.env.REACT_APP_SECRET_KEY ?? "";
export const ENCRYPTION_IV = process.env.REACT_APP_IV ?? "";

// APP_ENV reflects which environment we're targeting (development | uat | production)
export const APP_ENV = process.env.REACT_APP_ENV || "development";

// Firebase configuration
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? "",
};
